<template>
  <ls-table-layout>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button
        @click="$refs.dataCreateModal.show(Object.assign({}), defaultLookupType, defaultLookupTypeId)"
        type="primary"
        v-hasPermi="['system:lookup:add']">新增</a-button>
      <a-button
        @click="handleDeleteBatch(selectedRowKeys)"
        :disabled="selectedRowKeys.length === 0"
        v-hasPermi="['system:lookup:remove']">删除</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <a-table
          ref="table"
          :columns="columns"
          :loading="tableLoading"
          :data-source="dataList"
          :row-selection="rowSelection"
          row-key="id"
          :pagination="false"
          :scroll="{ x: 2500, y:'calc(100vh - 230px)' }">
          <!-- 更多选择 -->
          <span slot="action" slot-scope="text, record">
            <a @click="$refs.dataCreateModal.show(record, defaultLookupType, defaultLookupTypeId)" v-hasPermi="['system:lookup:edit']">编辑</a>
            <a href="javascript:;" class="ml10" @click="handleDelete(record)" v-hasPermi="['system:lookup:remove']">删除</a>
          </span>
          <!-- 插槽指向状态 -->
          <span slot="status" slot-scope="text, record">{{ statusFormat(record) }}</span>
          <span slot="isDefault" slot-scope="text, record">{{ isDefaultFormat(record) }}</span>
          <template slot="staDate" slot-scope="text">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="endDate" slot-scope="text">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <!-- attribute 属性 -->
          <span v-for="(item) in attributeList" :key="item.id" :slot="`${item.tblAttribute}Title`">
            <a-popover>
              <template slot="content">
                <p>{{ item.label }}</p>
              </template>
              <span v-if="item.label">{{ !item.tblValue ? item.tblAttribute : item.tblValue }}</span>
            </a-popover>
            <span v-if="!item.label">{{ !item.tblValue ? item.tblAttribute : item.tblValue }}</span>
          </span>
          <template v-for="(item) in attributeList">
            <span :key="item.id" :slot="item.tblAttribute" slot-scope="text">
              {{ text }}
            </span>
          </template>
        </a-table>
        <!-- 底部分页按钮 -->
        <a-pagination
          class="ant-table-pagination"
          v-model="pagination.current"
          :page-size-options="pagination.pageSizeOptions"
          :total="pagination.total"
          size="small"
          show-quick-jumper
          show-size-changer
          :page-size="pagination.pageSize"
          @showSizeChange="onShowSizeChange"
          @change="currentPageChange"
          :show-total="(total) => `共 ${total} 条数据`"
        >
        </a-pagination>
        <!-- 创建/编辑快码,单独封装了组件 -->
        <look-up-detail-add-edit ref="dataCreateModal" :attributeList="attributeList" @handle-success="handleOk" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiLookupDataDelete, apiLookupDataList } from '@/api/system/lookup/look-up-detail'
import LookUpDetailAddEdit from './components/look-up-detail-add-edit'
import { apiLookupAttributeList } from '@/api/system/lookup/type'
export default {
  // eslint-disable-next-line
  name: 'look-up-detail',
  components: {
    LookUpDetailAddEdit
  },
  data () {
    return {
      // 默认快码类型
      defaultLookupType: '',
      defaultLookupTypeId: '',
      // 快码表格数据
      dataList: [],
      // 状态数据快码
      statusOptions: [
        {
          dictLabel: "正常",
          dictValue: "0"
        },
        {
          dictLabel: "停用",
          dictValue: "1"
        }
      ],
      isDefaultOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      tableLoading: false,
      // 查询参数
      queryParams: {
        lookupTypeId: undefined
      },
      pagination: {
        current: 1,
        pageSize: 100,
        pageSizeOptions: ['10', ...this.$store.state.setting.pageSizeOptions],
        total: 0
      },
      // 表格字段
      columns: [
        {
          title: '快码',
          dataIndex: 'lookupType',
          width: 250,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '快码code',
          dataIndex: 'lookupCode',
          width: 250,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '含义',
          dataIndex: 'lookupValue',
          width: 250,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '快码值说明',
          dataIndex: 'remark',
          width: 250,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '生效时间',
          dataIndex: 'staDate',
          width: 180,
          scopedSlots: { customRender: 'staDate' },
          align: 'center'
        },
        {
          title: '失效时间',
          dataIndex: 'endDate',
          width: 180,
          scopedSlots: { customRender: 'endDate' },
          align: 'center'
        },
        {
          title: '操作',
          width: 140,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      parentId: "",
      attributeList: [] // attribute
    }
  },
  created () {
    const id = this.$route.query && this.$route.query.id
    const lookupType = this.$route.query && this.$route.query.lookupType
    this.parentId = this.$route.query && this.$route.query.parentId
    this.queryParams.lookupTypeId = id
    this.defaultLookupType = lookupType
    this.defaultLookupTypeId = id
    this.getList()
    this.getAttribute(id)
    // this.getDicts('sys_normal_disable').then((response) => {
    //   this.statusOptions = response.data
    // })
  },
  destroyed () {
    sessionStorage.setItem("parentId", this.parentId)
  },
  methods: {
    getAttribute (id) {
      const params = {
        lookupTypeId: id,
        pageNum: 1,
        pageSize: 100
      }
      apiLookupAttributeList(params).then(res => {
        if (res.code === 200 && res.rows && res.rows.length > 0) {
          const columns = JSON.parse(JSON.stringify(this.columns))
          res.rows.forEach((item, index) => {
            const obj = {
              dataIndex: item.tblAttribute,
              scopedSlots: { customRender: item.tblAttribute, title: `${item.tblAttribute}Title` },
              width: 250,
              ellipsis: true,
              align: 'center'
            }
            columns.splice(-1, 0, obj);
          });
          this.columns = columns

          this.attributeList = res.rows // attribute
        }
      })
    },
    /** pageSize 变化的回调 */
    onShowSizeChange (current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    },
    /** 页码改变的回调 */
    currentPageChange (current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    },
    /** 查询快码数据列表 */
    getList () {
      this.tableLoading = true
      const { current: pageNum, pageSize } = this.pagination
      apiLookupDataList({ ...this.queryParams, pageNum, pageSize }).then((response) => {
        this.dataList = response.rows
        this.pagination.total = response.total
        this.tableLoading = false
      })
    },
    // 数据状态快码翻译
    statusFormat (row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    isDefaultFormat (row) {
      return this.selectDictLabel(this.isDefaultOptions, row.isDefault)
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const lookupCode = row.lookupCode
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 快码编号为${lookupCode}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiLookupDataDelete(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 批量删除按钮操作 */
    handleDeleteBatch (ids) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 快码编号为${ids}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiLookupDataDelete(ids).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 新增/修改框事件
    handleOk () {
      this.getList()
    }
  }
}
</script>

<style  scoped lang="less">
.ml10{
  margin-left: 10px;
}
</style>
